// @ts-ignore
let apiHost = import.meta.env.VITE_API_HOST;
// @ts-ignore
let authHost = import.meta.env.VITE_AUTH_HOST;
// @ts-ignore
let frontendHost = import.meta.env.VITE_FRONTEND_HOST;
// @ts-ignore
let isProd = import.meta.env.PROD;

let proto = isProd ? 'https' : 'http';

export let config = {
  authFrontendUrl: `${proto}://${authHost}`,
  dashboardFrontendUrl: `${proto}://${frontendHost}`
};
